<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt" id="Hsimposios">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dCincoM dtOcho dmOnce" *ngFor="let ultimo of simposiosUltimo">
                    <h1>EVENTOS</h1>
                    <p>La educación continua de los médicos es esencial para nosotros primordial, para ello contamos con un programa permanente de actualización.</p>
                    <!---<div id="HsimposiosBtn">
                        <button type="button" class="btn" ><a  [routerLink]="'/simposio/' + ultimo.year +'/'+ ultimo.url ">SIMPOSIUM {{ultimo.year}}</a></button>
                    </div>--->
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
    </div>

    <div class="contenedorIntSub">
        <div class="FcfrCst">
            <div class="FcfrCstInt dSieteM dtDiez dmDoce flx">
                <div class="dCuatro FcfrBllt" >
                    <img src="./assets/images/icon-eventos-1.svg" alt="icon eventos"/>
                    <p class="FcifrasDatos">+ 15 eventos</p>
                    <p>EVENTOS REALIZADOS</p>
                </div>
            </div>
        </div>

    </div>



    <div class="Fsmp">
        <div class="dDiez dmDoce FsmpInt flx maxCnt">
            <div class="dCuatro dmDoce FsimposioTexto" *ngFor="let penultimo of simposiosPenultimo">
                <!--<h2 [innerHTML]="penultimo.titulo"></h2>-->
                <!---<p [innerHTML]="penultimo.intro"></p>--->
                <!---<div id="HsimposiosBtn">
                    <button type="button" class="btn">
                        <a  [routerLink]="'/simposio/' + penultimo.year +'/'+ penultimo.url ">SIMPOSIUM {{penultimo.year}}</a>
                    </button>  
                </div>--->
                <h2 style="text-align: center; margin-top: 1em;">ÚLTIMO EVENTO {{penultimo.year}}</h2>

                <div class="contenedorEvent" >
                    <div class="event-cont" >
                        <div class="event-img"><img src="./assets/images/eventos/eventos-mini.jpg" alt=""></div>
                        <p [innerHTML]="penultimo.intro"></p>
                        <div id="" class="btn-evento">
                            <button type="button" class="btn">
                                <a [routerLink]="'/simposio/' + penultimo.id +'/'+ penultimo.url ">Ver evento</a>
                            </button>  
                        </div>
                    </div>        
                </div>


            </div>
            <div class="dSieteM dmDoce  FsmpAnt">
                <div class="title-historico">
                    <div class="img-hist"><img src="./assets/images/icon-eventos-2.svg" alt="historico de eventos"></div>
                    <h3>HISTORICO DE EVENTOS</h3>
                </div>
                
                <div *ngFor="let simposio of simposios | paginate: {itemsPerPage: 6, currentPage: pageActual}" >
                    <div class="cont-hist" >
                        <div class="caj-start-text">
                            <div class="hist-img"><img alt="estrella historico" src="./assets/images/icon-eventos-start.svg"></div>
                            <div class="text-hist">
                                <p>{{simposio?.titulo}}<br>
                                <span>{{simposio.mes}} {{simposio.year}}</span></p>

                               <!-----<p><span>{{simposio?.titulo}} {{simposio.year}}</span></p>---->
                                
                            </div>
                        </div>
                        <!----<div class="but-hist" [routerLink]="'/simposio/' + simposio.year +'/'+ simposio.url ">
                            <button type="button" class="btn"><a >VER</a></button>  
                        </div>----->
                        <div class="but-hist" [routerLink]="'/simposio/' + simposio.id +'/'+ simposio.url ">
                            <button type="button" class="btn"><a >VER</a></button>  
                        </div>
                    </div>
                    <hr class="line-hist">

                   
                </div>
                <div class="dDoce Fpag">
                    <pagination-controls (pageChange)="pageActual = $event" previousLabel="Anterior" nextLabel="Siguiente" style="margin: auto; color: #ffffff;">
                    </pagination-controls>
                </div>


                <!---<div class="FsmpAntInt flx">
                    <div class="dTresM dmCincoM" *ngFor="let simposio of simposios">
                        <button type="button" ><a  [routerLink]="'/simposio/' + simposio.year +'/'+ simposio.url ">{{simposio.mes}} <span> {{simposio.year}} </span></a></button>
                    </div>
                </div>-->
            </div>

        </div>
    </div>
</div>